<template>
    <div>
        <welcome-bg/>
        <orientation/>
        <parent-advice/>
        <travel-accomadations/>
        <parents-f-a-q/>
        <upcoming-events/>
    </div>
</template>

<script>
    import WelcomeBg from "../components/parents/welcomeBg";
    import UpcomingEvents from "../components/home/upcomingEvents";
    import Orientation from "../components/parents/orientation";
    import TravelAccomadations from "../components/parents/travelAccomadations";
    import ParentAdvice from "../components/parents/parentAdvice";
    import ParentsFAQ from "../components/parents/parentsFAQ";
    export default {
        name: "parents",
        components: {ParentsFAQ, ParentAdvice, TravelAccomadations, Orientation, UpcomingEvents, WelcomeBg}
    }
</script>

<style scoped>

</style>
